import { useMutation } from '@tanstack/react-query';
import fetchData from '../fetcher';
import type { IamOrganizationDetail } from '../use-get-orgnaization-by-id/types';
import type { UpdateOrganizationPayload, UpdateOrganizationResponse } from './types';

export const toUpdateOrganizationPayload = (
  organization: IamOrganizationDetail,
  name: string
): UpdateOrganizationPayload => ({
  organizationId: organization.itemId,
  name,
  description: organization.description ?? '',
  defaultRoleForMembers: organization.defaultRoleForMembers ?? [],
  defaultPermissionsForMembers: organization.defaultPermissionsForMembers ?? [],
  email: organization.email ?? '',
  phoneNumber: organization.phoneNumber ?? '',
  websiteUrl: organization.websiteUrl ?? '',
  addresses: organization.addresses ?? [],
  attributes: organization.attributes ?? {},
  theme: organization.theme,
  logoUrl: organization.logoUrl,
  logoId: organization.logoId,
  industry: organization.industry,
  timeZone: organization.timeZone,
  currency: organization.currency,
  dateFormat: organization.dateFormat,
  timeFormat: organization.timeFormat,
  locale: organization.locale,
  isEnable: organization.isEnable,
});

export const useUpdateOrganization = () => {
  const { mutateAsync, data, isPending, error, isError } = useMutation({
    mutationKey: ['update-organization'],
    mutationFn: ({ organizationId, ...body }: UpdateOrganizationPayload) =>
      fetchData<UpdateOrganizationResponse>(`/iam/v4/iam/organizations/${organizationId}`, {
        body,
        method: 'POST',
        credentials: 'include',
      }),
  });

  return {
    updateOrganizationAsync: mutateAsync,
    data,
    isPending,
    error,
    isError,
  };
};

export default useUpdateOrganization;
